var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonthavekit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 192,
    viewBox: "0 0 312 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1468_603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.416 63.2949C118.416 63.2949 148.512 95.5812 160.382 103.223C179.507 115.535 203.219 119.54 216.017 119.735V147.648C216.017 147.648 194.131 152.281 159.764 138.064C149.497 133.814 136.484 127.427 128.165 116.213",
    fill: "#0C0E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.416 63.2949C118.416 63.2949 148.512 95.5812 160.382 103.223C179.507 115.535 203.219 119.54 216.017 119.735V147.648C216.017 147.648 194.131 152.281 159.764 138.064C149.497 133.814 136.484 127.427 128.165 116.213",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.044 144.704C128.597 105.417 130.408 81.9207 118.416 63.2951C87.9024 50.3705 73.2495 50.4354 49.9691 59.0663C54.2829 79.532 55.0019 90.5226 43.829 106.601C36.0784 127.716 38.0772 135.669 49.9691 144.704C71.7181 160.58 90.3973 157.145 127.044 144.704Z",
    fill: "white",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.316 112.425H205.088L195.591 120.659V154.749V170.322H277.331V120.659L267.316 112.425Z",
    fill: "white",
    stroke: "#0C0E1F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.267 180.742C76.2406 206.721 6.85944 178.844 1.98477 124.043C-4.57949 75.1373 49.9693 59.0952 49.9693 59.0952C49.9693 59.0952 55.908 64.3632 54.7936 78.8682C53.6792 93.3732 48.3228 98.6773 43.8292 106.63C30.1686 130.704 51.9033 146.818 70.2804 149.668C89.7862 152.699 126.533 147.987 146.348 144.422L149.267 180.742Z",
    fill: "#0C0E1F",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.525 26.4841C115.669 20.9708 115.395 16.2729 113.526 11.0482C112.649 10.3265 111.808 9.51101 110.974 8.7172C106.308 7.64195 101.627 6.73271 96.9031 6.03271C93.1938 8.52131 89.6907 11.3063 86.4277 14.3605C83.9257 19.2893 86.5931 17.0811 83.6884 23.4604C82.3942 30.5108 78.2817 43.9045 76.3333 53.1849C74.8953 53.3508 73.7162 53.0333 72.3789 53.0044C77.4117 60.3363 84.4218 65.8063 90.5475 72.1495C93.0567 66.1166 94.02 61.5486 96.5724 55.5518C95.3286 55.5518 93.8908 53.5456 92.6542 53.459L97.9602 33.4768C104.337 33.6644 107.515 32.6757 111.304 27.3933C112.628 26.785 114.069 26.4748 115.525 26.4841Z",
    fill: "white",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.928 1.23377C84.5519 6.61722 80.9354 11.9574 81.7982 21.9088C81.9995 24.1748 83.7826 25.0768 85.7598 24.5212C87.443 23.9254 89.0044 23.0281 90.3684 21.8728C90.9408 21.4 91.3274 20.7386 91.4591 20.0063C91.5908 19.2741 91.459 18.5187 91.0873 17.8749C90.9066 17.6113 90.7827 17.3128 90.7233 16.9985C90.6639 16.6841 90.6702 16.3608 90.7422 16.0491C91.4612 13.4728 92.784 13.0832 95.4946 13.4007C96.1121 13.4824 96.7398 13.434 97.3377 13.2588C97.9355 13.0836 98.4905 12.7854 98.9673 12.3832C99.2929 12.0446 99.6878 11.7808 100.125 11.6101C100.562 11.4394 101.03 11.3659 101.498 11.3945C104.971 11.51 109.091 11.813 112.477 12.0584C113.106 12.102 113.736 11.988 114.311 11.7265C118.035 9.92237 122.147 8.0461 119.127 3.96882C118.877 3.62714 118.524 3.3744 118.121 3.24718C109.917 -0.115669 102.9 -0.72188 94.1648 0.779135C93.7306 0.861906 93.3127 1.01549 92.928 1.23377Z",
    fill: "#0C0F1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.699 153.991C276.245 153.991 276.792 153.991 277.331 153.948V120.644L267.309 112.41H234.271C234.271 123.438 238.636 134.014 246.405 141.812C254.174 149.61 264.712 153.991 275.699 153.991Z",
    fill: "#F4B39E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.591 154.749V120.659H277.331V170.322H195.591V154.749Z",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.564 130.791H267.826",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.02 138.274H267.826",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.02 145.757H267.826",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.591 120.659L205.088 112.425H267.316L277.331 120.659",
    stroke: "#0C0E1F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.853 170.64C185.978 170.596 178.105 169.983 178.105 169.983C176.797 169.817 177.106 169.507 177.889 168.915L190.903 166.259C193.06 164.094 192.636 163.199 190.04 161.994H176.488C175.495 161.583 175.567 161.273 176.222 160.659C176.222 160.659 190.249 158.747 189.07 154.338C188.013 150.383 179.579 152.599 169.175 151.826C167.378 151.004 167.22 150.383 168.586 148.896C172.181 146.818 174.647 146.284 179.255 145.606C181.218 143.585 181.06 142.719 178.443 141.608C167.507 140.165 160.231 140.987 145.37 145.021L148.131 179.148C161.072 178.794 170.419 177.589 190.472 173.844C194.002 172.299 193.736 170.683 189.853 170.64Z",
    fill: "white",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.42 30.439C282.8 30.439 280.287 31.4836 278.434 33.3431C276.582 35.2026 275.541 37.7246 275.541 40.3543C275.541 45.8316 285.42 59.0664 285.42 59.0664C285.42 59.0664 295.298 45.8316 295.298 40.3543C295.298 37.7246 294.258 35.2026 292.405 33.3431C290.552 31.4836 288.04 30.439 285.42 30.439ZM285.42 44.345C284.633 44.345 283.865 44.1109 283.211 43.6724C282.557 43.2339 282.047 42.6107 281.746 41.8815C281.445 41.1523 281.367 40.3499 281.52 39.5758C281.673 38.8017 282.052 38.0906 282.608 37.5325C283.164 36.9744 283.873 36.5942 284.644 36.4403C285.415 36.2863 286.215 36.3653 286.941 36.6674C287.668 36.9694 288.289 37.4809 288.726 38.1372C289.162 38.7934 289.395 39.565 289.395 40.3543C289.393 41.4121 288.974 42.426 288.229 43.174C287.484 43.922 286.473 44.3431 285.42 44.345Z",
    fill: "#2A214A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.198 100.02H310.562V155.528H283.694",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.421 83.8691H195.591V100.019H223.739",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.002 63.2954V83.8694H258.501",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.262 52.1313C232.246 52.1313 227.436 54.1307 223.889 57.6898C220.341 61.2489 218.348 66.0763 218.346 71.1106C218.346 81.596 237.262 106.926 237.262 106.926C237.262 106.926 256.171 81.596 256.171 71.1106C256.171 66.077 254.179 61.2495 250.633 57.6902C247.086 54.131 242.277 52.1313 237.262 52.1313ZM237.262 78.7455C235.758 78.7455 234.287 78.2977 233.036 77.4588C231.785 76.6198 230.81 75.4274 230.234 74.0323C229.659 72.6372 229.508 71.1021 229.802 69.621C230.095 68.14 230.82 66.7796 231.883 65.7118C232.947 64.644 234.303 63.9169 235.778 63.6223C237.254 63.3277 238.783 63.4789 240.173 64.0568C241.563 64.6346 242.751 65.6132 243.587 66.8688C244.423 68.1244 244.869 69.6005 244.869 71.1106C244.87 72.1135 244.674 73.1067 244.292 74.0334C243.91 74.9602 243.349 75.8023 242.643 76.5114C241.936 77.2206 241.097 77.7829 240.174 78.1663C239.251 78.5497 238.261 78.7464 237.262 78.7455Z",
    fill: "#0C0F1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.163 49.0645C230.148 49.0645 225.338 51.0641 221.792 54.6234C218.246 58.1826 216.254 63.0101 216.254 68.0437C216.254 78.5291 235.163 103.859 235.163 103.859C235.163 103.859 254.08 78.5291 254.08 68.0437C254.078 63.0094 252.084 58.182 248.537 54.6229C244.989 51.0638 240.179 49.0645 235.163 49.0645ZM235.163 75.6786C233.659 75.6786 232.188 75.2308 230.937 74.3919C229.686 73.5529 228.711 72.3605 228.135 70.9654C227.56 69.5703 227.409 68.0352 227.702 66.5541C227.996 65.0731 228.72 63.7127 229.784 62.6449C230.848 61.5772 232.204 60.85 233.679 60.5554C235.155 60.2608 236.684 60.412 238.074 60.9899C239.464 61.5677 240.652 62.5463 241.488 63.8019C242.324 65.0575 242.77 66.5336 242.77 68.0437C242.77 70.0686 241.968 72.0106 240.542 73.4424C239.115 74.8742 237.181 75.6786 235.163 75.6786Z",
    fill: "#F4B39E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1468_603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 192,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonthavekit);
export default __webpack_public_path__ + "static/media/donthavekit.6d3bad9a364d256858dc3d7bc5bcec1c.svg";
export { ForwardRef as ReactComponent };